/* global Models */

Models.DateInterval = function (interval_spec) {
    /* private properties and methods */
    var value = 0;
    var days = 0;
    var hours = 0;
    var minutes = 0;
    var seconds = 0;
    var parseFormat = function (format) {
        if (format.days) days = format.days;
        if (format.hours) hours = format.hours;
        if (format.minutes) minutes = format.minutes;
        if (format.seconds) seconds = format.seconds;
        return (seconds + (minutes * 60) + (hours * 3600) + (days * 86400)) * 1000;
    };

    /* public properties and methods */
    this.getValue = function () {
        return value;
    };
    this.setValue = function (interval_spec) {
        value = parseFormat(interval_spec);
    };

    /* constructor */
    this.setValue(interval_spec);
};
